// extracted by mini-css-extract-plugin
export default {"Wrapper":"privacyPolicy_Wrapper__nXJRo","Content":"privacyPolicy_Content__ARvqH"};